var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRow2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.6,
    height: 128,
    viewBox: "0 0 93.6 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:#ff7043;}.d{fill:#ffee58;}.e{fill:#ffca28;}.f{fill:#ec407a;}.g{fill:#42a5f5;}.h{fill:#66bb6a;}.i{fill:#26c6da;}.j{fill:#d4e157;}.k{fill:#29b6f6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.8,71.7l-24,1.4,3.6-14.4ZM17.2,128l16.3-13.2-13.2.8Zm6.2-24.7-2,8.1,17.6-1,10.7-8.7Zm3.3-13.4-2.3,9.3L55,97.4l12.1-9.8Zm34-14.5L29.8,77.2l-2.1,8.5,44.9-2.6.1-.1ZM51.5,61.2c.1-1.4,2-34.3-16-44.2l-2,3.6c15.7,8.7,13.9,40,13.9,40.4Zm57.8-5,1.5-3.8C98.9,47.8,68.7,67.9,65.3,70.2l2.3,3.4C76.3,67.6,100.9,52.9,109.3,56.2ZM58.8,66.4C58.9,66,69,34.2,82.3,19.9l-3-2.8c-14,15-24.1,46.7-24.5,48ZM43.2,49.1l-3.1-8.9-8.9,3.1,3.1,8.9ZM80,78.1l-1.8-5.2,5.2-1.8,1.8,5.2Zm-6.8-22-1.8-5.2,5.2-1.8,1.8,5.2ZM56.6,34.3,54.7,29l5.2-1.8,1.8,5.2ZM64.2,7.1,62.4,1.9,67.6,0l1.8,5.2ZM96.9,43.9l-1.8-5.2,5.2-1.8,1.8,5.2Z",
    transform: "translate(-17.2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.4,58.7l20.4,13-24,1.4,3.6-14.4",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M60.7,75.4,29.8,77.2l-2.1,8.5,44.9-2.6.1-.1Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.7,89.9l-2.3,9.3L55,97.4l12.1-9.8Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.4,103.3l-2,8.1,17.6-1,10.7-8.7Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.2,128l16.3-13.2-13.2.8Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9.4,
    height: 9.4,
    transform: "translate(14.016 43.31) rotate(-19.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M64.2,7.1,62.4,1.9,67.6,0l1.8,5.2Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M51.5,61.2c.1-1.4,2-34.3-16-44.2l-2,3.6c15.7,8.7,13.9,40,13.9,40.4Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M56.6,34.3,54.7,29l5.2-1.8,1.8,5.2Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M58.8,66.4C58.9,66,69,34.2,82.3,19.9l-3-2.8c-14,15-24.1,46.7-24.5,48Z",
    transform: "translate(-17.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 5.5,
    height: 5.5,
    transform: "translate(77.839 38.672) rotate(-19.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.5,
    height: 5.5,
    transform: "translate(54.139 50.871) rotate(-19.093)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.5,
    height: 5.5,
    transform: "translate(60.938 72.872) rotate(-19.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M109.3,56.2l1.5-3.8C98.9,47.8,68.7,67.9,65.3,70.2l2.3,3.4C76.3,67.6,100.9,52.9,109.3,56.2Z",
    transform: "translate(-17.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow2);
export default __webpack_public_path__ + "static/media/row2.91f8dc5d1982031f05fbef23464394a4.svg";
export { ForwardRef as ReactComponent };